var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 18 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4D55",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M17 9.222c0 5.334-8 11.556-8 11.556S1 14.556 1 9.222c0-4.357 3.643-8 8-8s8 3.643 8 8"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4D55",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M9 11.889a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333"
})));
export default SvgLocation;